import { Col, Row, Placeholder } from '@thd-olt-component-react/core-ui';
import React, { useContext } from 'react';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { bool, number } from 'prop-types';
import { CarouselHeader } from './CarouselHeader';

const LoadingPlaceholder = ({
  hideTitle, itemsCount, itemHeight
}) => {

  const { channel } = useContext(ExperienceContext);

  const numOfLinesTxtPlaceholders = 10;
  const isMobile = channel === 'mobile';
  let numOfPlaceholders = isMobile ? 2 : 6;
  let placeholderHeight = isMobile ? '200px' : '290px';

  if (itemsCount) {
    numOfPlaceholders = itemsCount;
  }

  if (itemHeight) {
    placeholderHeight = (itemHeight - 170) + 'px';
  }

  return (
    <Row>
      {!hideTitle && <CarouselHeader title="Loading Recommendations" />}
      <Row key="placeholder-row">
        {[...Array(numOfPlaceholders)].map((__, ind) => (
          <Col fallback={isMobile ? '6' : '2'} xs="2" key={`pod-placeholder-${ind}`}>
            <Placeholder type="rect" height={placeholderHeight} />
            {new Array(numOfLinesTxtPlaceholders).fill('').map((___, i) => (
              <Placeholder type="text" key={`txt-row-${i}`} />
            ))}
          </Col>
        ))}
      </Row>
    </Row>
  );
};

LoadingPlaceholder.propTypes = {
  hideTitle: bool,
  itemsCount: number,
  itemHeight: number,
};

LoadingPlaceholder.defaultProps = {
  hideTitle: false,
  itemsCount: null,
  itemHeight: null,
};

export { LoadingPlaceholder };
